import React from "react";
import PropTypes from "prop-types";
import PhoneField from "../../../common/PhoneField";

function renderPhoneField({
  label,
  input,
  meta: {touched, invalid, error},
  ...custom
}) {
  return (
    <PhoneField
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      fullWidth
      {...input}
      {...custom}
    />
  );
}

renderPhoneField.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default renderPhoneField;
